import { render, staticRenderFns } from "./addYGDLR.vue?vue&type=template&id=7aaa76c2&"
import script from "./addYGDLR.vue?vue&type=script&lang=js&"
export * from "./addYGDLR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports